import { render, staticRenderFns } from "./sso-logout-loading.vue?vue&type=template&id=66ea213c&scoped=true&"
import script from "./sso-logout-loading.vue?vue&type=script&lang=js&"
export * from "./sso-logout-loading.vue?vue&type=script&lang=js&"
import style0 from "./sso-logout-loading.vue?vue&type=style&index=0&id=66ea213c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea213c",
  null
  
)

export default component.exports